import { render, staticRenderFns } from "./popup_gift_product.vue?vue&type=template&id=e13c4a4a&scoped=true&"
import script from "./popup_gift_product.vue?vue&type=script&lang=js&"
export * from "./popup_gift_product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e13c4a4a",
  null
  
)

export default component.exports